/* ==============================================================================================
 * LOGIN PASSWORD SEND MESSAGE
 * ============================================================================================== */

var Sushi, Icons;

(function (Sushi, Icons) {
	"use strict";

	var passwordForm = document.querySelector("#forgotPassword");

	if (!passwordForm) {
		return;
	}

	var messageContainer = passwordForm.querySelector("[data-success-message]");
	var sentEmailContainer = passwordForm.querySelector("[data-success-sent-email]");
	var submitButton = passwordForm.querySelector("button");

	Sushi.Events(passwordForm).on("submit", function (event) {
		event.preventDefault();

		var emailValue = passwordForm.querySelector("input").value;

		if (emailValue) {
			submitButton.classList.add("c-btn--success");
			submitButton.children[1].innerHTML = Icons.check();
			sentEmailContainer.innerHTML = "A message was sent to " + emailValue;

			$(messageContainer).fadeIn();
		}
	});

})(Sushi || (Sushi = {}), Icons || (Icons = {}));
